import { MovieOpenCheckIcon } from './MovieOpenCheckIcon';

/**
 * author: Colton Wiscombe
 * id C3078403-9C18-4F30-983B-E755B9CBA37B
 * name movie-open-check
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-open-check.svg
 * tags
 * - Video / Movie 
 */
export const FilmOpenCheckIcon = MovieOpenCheckIcon;
export default FilmOpenCheckIcon